var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsArray, IsBoolean, IsEnum, IsInt, IsOptional, IsString, MaxLength, } from 'class-validator';
import { CustomFormElementType } from '../enums/custom-form-element-type.enum.js';
export class CreateCustomFormElementDto {
    label;
    index;
    options;
    mandatory;
    type;
    imageFilename;
    description;
    placeholder;
}
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(255),
    __metadata("design:type", String)
], CreateCustomFormElementDto.prototype, "label", void 0);
__decorate([
    IsOptional(),
    IsInt(),
    __metadata("design:type", Number)
], CreateCustomFormElementDto.prototype, "index", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    __metadata("design:type", Array)
], CreateCustomFormElementDto.prototype, "options", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], CreateCustomFormElementDto.prototype, "mandatory", void 0);
__decorate([
    IsOptional(),
    IsEnum(CustomFormElementType),
    __metadata("design:type", String)
], CreateCustomFormElementDto.prototype, "type", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], CreateCustomFormElementDto.prototype, "imageFilename", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(500),
    __metadata("design:type", Object)
], CreateCustomFormElementDto.prototype, "description", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(255),
    __metadata("design:type", Object)
], CreateCustomFormElementDto.prototype, "placeholder", void 0);
//# sourceMappingURL=create-custom-form-element.dto.js.map